export const categorySelectTwoFourIntroSteps = [
  {
    element: '.student-dropdown-row:nth-child(1)',
    intro: 'Click here to view all of the connected texts second through fourth grade students are reading in the WordFlight System.'
  },
];